import React from "react";
import { THEMES } from "../theme/themes";
import { useTheme } from "../theme/ThemeContext";

const ThemeSwitch = () => {
  const { themeId, setThemeId } = useTheme();

  return (
    <div className="biz-theme-switch" role="radiogroup" aria-label="Color theme">
      {Object.values(THEMES).map((theme) => {
        const selected = themeId === theme.id;
        return (
          <button
            key={theme.id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`biz-theme-swatch${selected ? " is-on" : ""}`}
            style={{ "--swatch-color": theme.primary }}
            title={`${theme.label} theme`}
            aria-label={`${theme.label} theme`}
            onClick={() => setThemeId(theme.id)}
          />
        );
      })}
    </div>
  );
};

export default ThemeSwitch;
